/** @hidden */
export var DEFAULT_DIALOGS_ZINDEX = 10002;
